// -----------------------------------------------------------------------------
// Constants
// -----------------------------------------------------------------------------

export const NAME = 'dfbSpinner'
const CLASS = 'dfb-Spinner'
const EVENT_KEY = `${NAME}:`

export const ClassName = {
  ROOT: CLASS,
  ROOT_CONTINUOUS: `${CLASS}--continuous`,
  ROOT_CHECKMARK: `${CLASS}--checkmark`,
  VALUE: `${CLASS}-value`,
  SVG: `${CLASS}-svg`,
  PATH: `${CLASS}-path`,
  PATHPROGRESS: `${CLASS}-pathProgress`,
  GROUP: `${CLASS}-group`,
  GROUPBASE: `${CLASS}-groupBase`,
  GROUPPROGRESS: `${CLASS}-groupProgress`,
  SVGCHECKMARK: `${CLASS}-svgCheckmark`,
  PATHCHECKMARK: `${CLASS}-pathCheckmark`
}

export const States = {
  PENDING: `is-pending`,
  LOADING: `is-loading`,
  COMPLETE: `is-complete`,
  STARTED: `is-started`,
  HIDDEN: `is-hidden`
}

export const Selector = {
  ROOT: `.${ClassName.ROOT}`,
  VALUE: `.${ClassName.VALUE}`,
  SVG: `.${ClassName.SVG}`,
  PATH: `.${ClassName.PATH}`,
  PATHPROGRESS: `.${ClassName.PATHPROGRESS}`,
  GROUP: `.${ClassName.GROUP}`,
  GROUPBASE: `.${ClassName.GROUPBASE}`,
  GROUPPROGRESS: `.${ClassName.GROUPPROGRESS}`,
  SVGCHECKMARK: `.${ClassName.SVGCHECKMARK}`,
  PATHCHECKMARK: `.${ClassName.PATHCHECKMARK}`
}

export const Event = {
  PENDING: `${EVENT_KEY}pending`,
  STARTED: `${EVENT_KEY}started`,
  LOADING: `${EVENT_KEY}loading`,
  COMPLETE: `${EVENT_KEY}complete`,
  HIDDEN: `${EVENT_KEY}hidden`
}

export const LoopSettings = {
  DURATION: 2,
  ANIMATION: [
    {
      dashLength: 0,
      dashOffset: 0,
      rotate: 0
    },
    {
      dashLength: 0.65,
      dashOffset: -1,
      rotate: 360
    }
  ]
}
